import { getOrCreateDeviceId } from "./device-id";

const isCWBrowser = () => !!window.electronAPI?.mesh;

const broadcastMeshEvent = (type, payload) => {
  if (!isCWBrowser()) return false;

  try {
    window.electronAPI.mesh.send(type, {
      ...payload,
      sourceDeviceId: getOrCreateDeviceId(),
    });
    return true;
  } catch (err) {
    console.error("[meshBroadcast] Failed to send:", type, err);
    return false;
  }
};

const broadcastTableStatus = (tableData) => {
  return broadcastMeshEvent("table:status", {
    fbTableId: tableData.cwrFbTableId,
    status: tableData.statusType,
    guestName: tableData.guestName || "",
    noOfPersons: tableData.noOfPersons || 0,
    guestType: tableData.guestType || "",
    waiter: tableData.waiter || "",
    salesRepId: tableData.salesRepId || tableData.waiter || "",
    merges: tableData.merge || [],
    color: tableData.color,
    ordered: tableData.ordered,
    startedAt: tableData.startedAt,
  });
};

const broadcastOrderUpsert = (orderData) => {
  return broadcastMeshEvent("cart:sync", {
    fbOrderId: orderData.fbOrderId,
    fbTableId: orderData.cwrFbTableId || orderData.fbTableId,
    status: orderData.fbOrderStatus || orderData.status,
    lines: orderData.lines || [],
    meta: orderData.meta || [],
    isCanceled: orderData.isCanceled || "N",
  });
};

const broadcastKOT = (kotData, tableName) => {
  return broadcastMeshEvent("kot:new", {
    fbOrderId: kotData.fbOrderId,
    fbTableId: kotData.fbTableId || kotData.cwrFbTableId,
    tableName: tableName || "",
    items: kotData.items || [],
    kotNumber: kotData.kotNumber,
  });
};

const broadcastKOTCancel = (cancelData) => {
  return broadcastMeshEvent("kot:cancel", {
    fbOrderId: cancelData.fbOrderId,
    fbTableId: cancelData.fbTableId,
    cancelledItems: cancelData.cancelledItems || [],
    remarks: cancelData.remarks || "",
  });
};

export {
  isCWBrowser,
  broadcastMeshEvent,
  broadcastTableStatus,
  broadcastOrderUpsert,
  broadcastKOT,
  broadcastKOTCancel,
};
